/* unplugin-vue-components disabled */import script from "./AssignCourseCollectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignCourseCollectionModal.vue?vue&type=script&setup=true&lang=js"

import "./AssignCourseCollectionModal.vue?vue&type=style&index=0&id=63aac5ec&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63aac5ec"]])

export default __exports__